export const FINANCIAL_REPORT_COMPLETE_MANUAL_EXTRACT = 'CMEX';
export const FINANCIAL_REPORT_REVIEW_BANK_DEPOSIT_SLIP = 'RBDS';
export const FINANCIAL_REPORT_SEE_EXTRACTION_FILES = 'SXTF';
